import React, { useState } from "react";
import Hero from "../components/Hero";
import HeroImage from "../../assets/images/ContactUsPage.jpg";
import "../../css/ContactUs.css";
import { useNavigate } from "react-router-dom";

function ContactUsPage() {
  const [form, setForm] = useState({
    name: "",
    number: "",
    email: "",
    message: "",
    consent: false,
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    // clear field error as user types
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const next = {};

    if (!form.name.trim()) next.name = "Name is required";
    if (!form.number.trim()) next.number = "Number is required";
    if (!form.email.trim()) next.email = "Email is required";
    if (!form.message.trim()) next.message = "Message is required";
    if (!form.consent)
      next.consent = "Please confirm you have read the privacy policy";

    setErrors(next);
    return Object.keys(next).length === 0;
  };

  /**
   * Runs automatically on Google Form submit (installable trigger).
   * Sends the form response to your Node endpoint.
   */
const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    if (!validate()) return;

    const to = process.env.REACT_APP_ADVISER_EMAIL;

    const payload = {
      name: form.name.trim(),
      email: form.email.trim(),
      number: form.number.trim(),
      message: form.message.trim(),
      to: (to || "").trim(),
    };

    const url = `${process.env.REACT_APP_SERVER_URL}/send-adviser-contact-confirmation`;

    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const errText = await res.text();
      console.log("API error:", errText);
      return;
    }

    // optional: success UI / reset
    setForm({
      name: "",
      number: "",
      email: "",
      message: "",
      consent: false,
    });

    setErrors({});
    console.log("Sent successfully");
  } catch (err) {
    console.log("handleSubmit error:", err);
  }
};

  return (
    <>
      <Hero
        title={"Start your journey with us"}
        subtitle={""}
        backgroundImage={HeroImage}
      />

      {/*  CONTACT FORM */}
      <section className="contact-form-wrap">
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="contact-row">
            <div className="contact-field">
              <label>Name:</label>
              <input
                name="name"
                value={form.name}
                onChange={handleChange}
                className={errors.name ? "has-error" : ""}
              />
              {errors.name ? (
                <span className="error-text">{errors.name}</span>
              ) : null}
            </div>

            <div className="contact-field">
              <label>Number:</label>
              <input
                name="number"
                value={form.number}
                onChange={handleChange}
                className={errors.number ? "has-error" : ""}
              />
              {errors.number ? (
                <span className="error-text">{errors.number}</span>
              ) : null}
            </div>
          </div>

          <div className="contact-field">
            <label>Email:</label>
            <input
              name="email"
              value={form.email}
              onChange={handleChange}
              className={errors.email ? "has-error" : ""}
            />
            {errors.email ? (
              <span className="error-text">{errors.email}</span>
            ) : null}
          </div>

          <div className="contact-field">
            <label>Message:</label>
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              rows={8}
              className={errors.message ? "has-error" : ""}
            />
            {errors.message ? (
              <span className="error-text">{errors.message}</span>
            ) : null}
          </div>

          <div className="contact-consent">
            <input
              type="checkbox"
              name="consent"
              checked={form.consent}
              onChange={handleChange}
              id="consent"
            />
            <label htmlFor="consent">
              *I confirm I have read the{" "}
              <span
                // href="/privacy-policy"
                // target="_blank"
                // rel="noopener noreferrer"
                style={{ textDecoration: "underline", cursor: "pointer" }}
                onClick={() => navigate("/privacy-policy")}
              >
                privacy policy
              </span>
            </label>
          </div>

          <button className="contact-submit" type="submit">
            Submit
          </button>
        </form>
        {errors.consent ? (
          <span className="error-text">{errors.consent}</span>
        ) : null}
      </section>

      <div className="footer-disclaimer">
        <div className="footer-Content Column">
          <p>
            Before you supply any personal details to us via the contact us
            page, please read our IFA privacy notice document at the bottom of
            the website. This notice sets out how we will process your personal
            data in line with the General Data Protection Regulations. Once you
            have read the privacy notice, please tick to confirm that you have
            read it and that you agree to Ava Rose Mortgages Ltd processing your
            personal information for the purpose of contacting you. We will not
            use the details you provide us in the contact form to market to you.
          </p>
        </div>
      </div>
      <div className="text-button-container">
        <h2 className="ContactUs">Complaints Procedure</h2>
        <div className="divider"></div>
        <p>
          If you wish to register a complaint, please write to Complaints
          Officer, Rosemount Financial Solutions IFA Ltd, Rosemount House, 2-4
          Chequers Road, Basingstoke, RG21 7PU. Telephone
          <a href="tel:01256405460"> 01256 405460</a> or e-mail{" "}
          <a href="mailto:complaints@rosemountfsIFA.co.uk">
            complaints@rosemountfsIFA.co.uk
          </a>
          . A summary of our internal complaints handling procedures for the
          reasonable and prompt handling of complaints is available on request
          and if you cannot settle your complaint with us, you may be entitled
          to refer it to the Financial Ombudsman Service at{" "}
          <a
            href="https://www.financial-ombudsman.org.uk"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.financial-ombudsman.org.uk
          </a>{" "}
          or by contacting them on <a href="tel:08000234567">0800 023 4567</a>.
        </p>
      </div>
    </>
  );
}

export default ContactUsPage;
